// extracted by mini-css-extract-plugin
export default {"animate__fadeInUp":"animate__animate__fadeInUp___zVJAI","animateFadeInUp":"animate__animate__fadeInUp___zVJAI","fadeInUp":"animate__fadeInUp___ec9kh"};